import ApiService from '@/common/api.service'

export default {
  state: {
    programs: [],
    basedOnPrograms: [],
    programTypes: [],
    durationUnits: [],
    subjectTypes: [],
    lang: localStorage.getItem('language') || 'ar',
  },
  getters: {
    programs(state) {
      return state.programs
    },
    basedOnPrograms(state) {
      return state.basedOnPrograms
    },
    programsOptions(state) {
      return state.programs
        .filter(p => p.is_active)
        .map(program => ({
          id: program.id,
          title: program.title[state.lang],
          type: program.type,
          duration_unit: program.duration_unit,
          entity_id: program.entity_id,
        }))
    },
    programsByEntityId(state) {
      return entity_id =>
        state.programs
          .filter(program => program.entity_id === entity_id)
          .map(program => ({
            id: program.id,
            title:
              program.title[state.lang] +
              (program.duration_unit ? ` (${program.duration_unit.title[state.lang]})` : ''),
          }))
    },
    programTypes(state) {
      return state.programTypes
    },
    durationUnits(state) {
      return state.durationUnits
    },
    subjectTypes(state) {
      return state.subjectTypes
    },
  },
  mutations: {
    setPrograms(state, programs) {
      state.programs = programs
    },
    setBasedOnPrograms(state, basedOnPrograms) {
      state.basedOnPrograms = basedOnPrograms
    },
    setProgramTypes(state, data) {
      return (state.programTypes = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
    setDurationUnits(state, data) {
      return (state.durationUnits = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
    setSubjectTypes(state, data) {
      return (state.subjectTypes = data.map(item => ({ id: item.id, title: item.title[state.lang] })))
    },
  },
  actions: {
    async getPrograms({ state, commit }, payload) {
      if (state.programs.length && !payload?.force) return
      const { data } = await ApiService.query('programs', { ...payload })
      return commit('setPrograms', data)
    },
    async getBasedOnPrograms({ state, commit }, payload) {
      if (state.basedOnPrograms.length && !payload?.force) return
      const { data } = await ApiService.query('based-on-programs', { ...payload })
      return commit('setBasedOnPrograms', data)
    },
    async getProgramTypes({ state, commit }) {
      if (state.programTypes.length) return
      const { data } = await ApiService.query('program-types', { lang: state.lang })
      return commit('setProgramTypes', data)
    },
    async getDurationUnits({ state, commit }) {
      if (state.durationUnits.length) return
      const { data } = await ApiService.query('duration-units', { lang: state.lang })
      return commit('setDurationUnits', data)
    },
    async getSubjectTypes({ state, commit }) {
      if (state.subjectTypes.length) return
      const { data } = await ApiService.query('subject-types', { lang: state.lang })
      return commit('setSubjectTypes', data)
    },
  },
}
